import React from 'react';
import SigniteButton from '../../../ui-elements/signite-button/signiteButton';
import { Modal, Button, Row, Col, Container, Form } from 'react-bootstrap';
import './forgotPassword.css';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
export const ResetPasswordDialog = ({ show, setShow, flowConfig, usernameOrEmail, otp, newPassword, setNewPassword, confirmPassword, setConfirmPassword, showNewPassword, showConfirmPassword, toggleShowNewPassword, toggleShowConfirmPassword }) => (

  <Modal show={show} onHide={() => setShow(false)} centered>
    <Modal.Header closeButton className='forgot-pwd-close'>
      <Modal.Title
        style={{ textAlign: 'center', width: '100%', color: '#2D3E50', fontFamily: 'Poppins', fontWeight: 600 }}
      >
        Set New Password
      </Modal.Title>
    </Modal.Header>
    <Modal.Body className="forgot-password-body">
      <Container>
        <Row className="d-flex align-items-center justify-content-center">
          <Form.Group as={Row} className="pt-3 d-flex align-items-center justify-content-center">
            <Form.Label className="ps-0">Password</Form.Label>
            <div style={{ position: 'relative' }} className='ps-0'>
              <Form.Control
                style={{ boxShadow: 'none', paddingRight: '2.5rem' }}
                className='forgot-login-input'
                type={showNewPassword ? 'text' : 'password'}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <span
                onClick={toggleShowNewPassword}
                style={{
                  position: 'absolute',
                  right: '18px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  color: '#6c757d',
                }}
              >
                <FontAwesomeIcon icon={showNewPassword ? faEyeSlash : faEye} />
              </span>
            </div>
          </Form.Group>
          <Form.Group as={Row} className="pt-3 d-flex align-items-center justify-content-center">
            <Form.Label className="ps-0">Confirm Password</Form.Label>
            <div style={{ position: 'relative' }} className='ps-0'>
              <Form.Control
                style={{ boxShadow: 'none', paddingRight: '2.5rem' }}
                type={showConfirmPassword ? 'text' : 'password'}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className='forgot-login-input'
              />
              <span
                onClick={toggleShowConfirmPassword}
                style={{
                  position: 'absolute',
                  right: '18px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  color: '#6c757d',
                }}
              >
                <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
              </span>
            </div>
          </Form.Group>
        </Row>
        <Row>
          <Col className="p-2 d-flex align-items-center justify-content-center">
            <SigniteButton
              variant="primary"
              className="verifyotp-button mt-3 p-3"
              disabled={!newPassword || !confirmPassword}
              onClick={(e) => {
                e.preventDefault();
                flowConfig.verify(usernameOrEmail, otp, newPassword, confirmPassword);
              }}
            >
              Reset Password
            </SigniteButton>

          </Col>
        </Row>
      </Container>
    </Modal.Body>
  </Modal>
);